import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, Observable, throwError } from 'rxjs';
import { environment } from '../../environments/environment';
import { Transporte } from '../models/Transporte';
import {MaintenanceTransportistaLite} from "../models/MaintenanceTransportistaLite";


@Injectable({
    providedIn: 'root'
})
export class TransporteService {

    private url = "";
    private apiEndpoint = environment.transporteApiEndpoint;

    constructor(private readonly httpClient:HttpClient) { }

    getTransporteTable(): Observable<Transporte[]> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.get<Transporte[]>(this.url).pipe(
          map((res: Transporte[]) => {
            return res.map((transporte) => Transporte.transformTransporte(transporte))
          })
        );
    }

    getTransporteLiteTable(): Observable<MaintenanceTransportistaLite[]> {
      this.url = `${this.apiEndpoint}/lite`;
      console.log(this.url);
      return this.httpClient.get<MaintenanceTransportistaLite[]>(this.url);
    }

    addUpdateTransp(transporte: Transporte, add: boolean): Observable<Transporte> {
        if (add) {
          return this.addTransp(transporte);
        } else {
          return this.updateTransp(transporte);
        }
      }

      addTransp(transporte: Transporte): Observable<Transporte> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.post<Transporte>(this.url, transporte).pipe(
          map((res: any) => {
            return Transporte.transformTransporte(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for transporte: " + transporte);
            return throwError(err);
          })
        );
      }

      updateTransp(transporte: Transporte): Observable<Transporte> {
        this.url = this.apiEndpoint;
        console.log(this.url);
        return this.httpClient.put<Transporte>(this.url, transporte).pipe(
          map((res: any) => {
            return Transporte.transformTransporte(res);
          }),
          catchError((err: any) => {
            console.log("Saving failed for transporte: " + transporte);
            console.log(transporte);
            return throwError(err);
          })
        );
      }
}
